<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>photo_library</md-icon>
          </div>
          <h4 class="title">Wingio Product Images</h4>
        </md-card-header>

        <md-card-content>
            <h3 class="product-title" v-if="produtDetail">{{ produtDetail.name }}</h3>
          <!-- 🔁 Display Images -->
          <div class="image-gallery">
            <!-- Image thumbnails -->
            <div v-for="(img, index) in productImages" :key="index" class="image-wrapper" :class="{ 'is-primary': isPrimaryImage(img.productImage) }">
                <!-- Primary Badge -->
                <span v-if="isPrimaryImage(img.productImage)" class="primary-badge">
                  <md-icon class="badge-icon">star</md-icon>
                  Primary
                </span>
                
                <img :src="img.productImage" class="image-preview" @click="openImage(img.productImage)" style="cursor: pointer" />
                
                <!-- Action Icons -->
                <div class="action-icons">
                  <a v-if="!isPrimaryImage(img.productImage)" href="javascript:void(0)" @click="setPrimaryImage(img.productImage)" title="Set as Primary">
                    <md-icon class="primary-icon">star_border</md-icon>
                  </a>
                  <a href="javascript:void(0)" @click="deleteImage(img._id)" title="Delete Image">
                    <md-icon class="delete-icon">delete</md-icon>
                  </a>
                </div>
            </div>
          </div>

          <!-- ⬆️ Drag & Drop Upload -->
          <div
            class="upload-area"
            @dragover.prevent
            @drop.prevent="handleDrop"
            @click="triggerFileInput"
        >
            <md-icon>cloud_upload</md-icon>
            <p>Drag & Drop or Click to Upload</p>
            <input
            type="file"
            ref="fileInput"
            multiple
            accept="image/*"
            @change="handleFileChange"
            style="display: none"
            />
        </div>

          <div v-if="showPreview" class="image-modal" @click.self="closePreview">
  <div class="image-modal-content">
    <span class="close-btn" @click="closePreview">&times;</span>
    <img :src="selectedImage" class="preview-image" />
  </div>
</div>


        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import ProductService from "../../../services/ProductService";

export default {
  components: {
    
  },
  data() {
    return {
        productdId: this.$route.query.id,
        productImages: [],
        showPreview: false,      // Controls modal visibility
        selectedImage: null ,
        produtDetail: null,
    };
  },
  methods: {
    getProductImages() {
        ProductService.getProductImages({ id: this.productdId })
          .then((response) => {
            this.productImages = response.data.data;
            this.produtDetail = response.data.produtDetail
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    deleteImage(id) {
      ProductService.deleteProductImages({ id: id })
        .then((response) => {
            this.$toast.success(response.data.respones_msg);
            this.getProductImages()
        })
        .catch((e) => {
        this.$toast.error(e.response.data.respones_msg);
    });
    },
    isPrimaryImage(imageUrl) {
      if (!this.produtDetail || !this.produtDetail.mainImage) return false;
      // Extract filename from full URL
      const imageName = imageUrl.split('/').pop();
      return this.produtDetail.mainImage === imageName;
    },
    setPrimaryImage(imageUrl) {
      // Extract filename from full URL
      const imageName = imageUrl.split('/').pop();
      
      ProductService.updatePrimaryImage({ 
        productId: this.productdId, 
        mainImage: imageName 
      })
        .then((response) => {
          this.$toast.success(response.data.respones_msg || "Primary image updated successfully!");
          this.getProductImages(); // Refresh to show updated primary image
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Failed to update primary image");
        });
    },
    openImage(img) {
        this.selectedImage = img;
        this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
      this.selectedImage = null;
      this.removeEscapeListener();
    },
    handleEscape(event) {
      if (event.key === 'Escape') {
        this.closePreview();
      }
    },
    addEscapeListener() {
      document.addEventListener('keydown', this.handleEscape);
    },
    removeEscapeListener() {
      document.removeEventListener('keydown', this.handleEscape);
    },
    triggerFileInput() {
        this.$refs.fileInput.click();
    },

  handleFileChange(e) {
    const files = Array.from(e.target.files);
    this.previewSelectedImages(files);
    e.target.value = ""; // Reset input for future uploads
  },

  handleDrop(e) {
    const files = Array.from(e.dataTransfer.files);
    this.previewSelectedImages(files);
  },

  previewSelectedImages(files) {
    const imageFiles = files.filter(file => file.type.startsWith("image/"));
    if (imageFiles.length === 0) return;

    const formData = new FormData();
    formData.append("productId", this.productdId);

    imageFiles.forEach(file => {
        formData.append("images[]", file); // Append each file to the array
    });

    ProductService.uploadProductImages(formData)
        .then(() => {
            this.$toast.success("Images uploaded successfully!");
            this.getProductImages(); // Refresh after upload
        })
        .catch((err) => {
            this.$toast.error("Upload failed: " + (err.response?.data?.message || err.message));
        });
    }
  },
  watch: {
    showPreview(newVal) {
      if (newVal) {
        this.addEscapeListener();
      } else {
        this.removeEscapeListener();
      }
    },
  },
  beforeMount() {
    this.getProductImages()
    this.removeEscapeListener();
  },
};
</script>

<style scoped>
.image-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
}

.image-wrapper {
  position: relative;
  width: 120px;
  height: 120px;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: #fff;
  transition: all 0.3s ease;
}

.image-wrapper:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.image-wrapper.is-primary {
  border: 2px solid #4caf50;
  box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
}

.primary-badge {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
  color: white;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.badge-icon {
  font-size: 14px !important;
  color: white !important;
}

.image-preview {
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
  margin-top: 20px;
}

.action-icons {
  position: absolute;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 3;
}

.primary-icon {
  font-size: 20px !important;
  color: #ff9800 !important;
  background: white;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.primary-icon:hover {
  color: #f57c00 !important;
  transform: scale(1.15);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
}

.delete-icon {
  font-size: 20px !important;
  color: #f44336 !important;
  background: white;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.delete-icon:hover {
  color: #d32f2f !important;
  transform: scale(1.15);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
}

.upload-area {
  border: 2px dashed #4caf50;
  border-radius: 6px;
  text-align: center;
  padding: 30px;
  cursor: pointer;
  color: #666;
  transition: background 0.3s;
}

.upload-area:hover {
  background: #f4fff4;
}

.image-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
}

.image-modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.preview-image {
  width: 100%;
  height: auto;
  max-height: 80vh;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.5);
}

.close-btn {
  position: absolute;
  top: -30px;
  right: -30px;
  font-size: 3rem;
  color: white;
  cursor: pointer;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  padding: 5px 10px;
  line-height: 1;
}

.product-title {
  margin-bottom: 20px;
  color: #333;
}
</style>